import { Link } from "react-router-dom";
import { ArcoLogo, BOOKING_URL } from "./shared";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-14 bg-[#080F26]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
        <div className="text-center md:text-left">
          <ArcoLogo />
          <p className="text-white/45 text-sm mt-3 max-w-xs">
            Inbound calls, ranked and delivered.
          </p>
        </div>
        <nav
          data-testid="footer-nav"
          className="flex flex-wrap items-center justify-center gap-6 text-sm text-white/60"
        >
          <Link to="/" className="hover:text-white transition-colors">
            Home
          </Link>
          <Link
            to="/appointments"
            className="hover:text-white transition-colors"
            data-testid="footer-link-pay-per-call"
          >
            Pay-Per-Call
          </Link>
          <a href="/#faq" className="hover:text-white transition-colors">
            FAQ
          </a>
          <a href="#" className="hover:text-white transition-colors">
            Privacy
          </a>
          <a href="#" className="hover:text-white transition-colors">
            Terms
          </a>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noreferrer"
            className="hover:text-white transition-colors"
          >
            Contact
          </a>
        </nav>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-10 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/35">
        <div>© 2026 Arco Scaling. All rights reserved.</div>
        <div className="font-mono uppercase tracking-widest">
          Inbound &middot; Ranked &middot; Delivered
        </div>
      </div>
    </footer>
  );
}
